angular
  .module("impactx.list")
  .service("ListFilterService", ["$mdSidenav", ListFilterService]);

function ListFilterService($mdSidenav) {
  var self = this;
  self.sidebarIdentifier = "listFilterSidebar";
  self.persistentFiltersCollapsed = {
    value: true,
  };
  self.selectedFilter = {
    entries: [],
    amount: 0,
  };

  function getAngularService() {
    if (ixUpgrade && typeof ixUpgrade.getAngularService === 'function') {
      return ixUpgrade.getAngularService("ListFilterService");
    }
    return null;
  }

  function hasSidenavElement() {
    var el = document.getElementById("listFilterSidebarRawId");
    return !!el;
  }

  function togglePersistentFilters() {
    if (!isOpen()) {
      open();
      self.persistentFiltersCollapsed.value = false;
    } else {
      self.persistentFiltersCollapsed.value =
        !self.persistentFiltersCollapsed.value;
    }

    const angularService = getAngularService();

    if (angularService && angularService.isActive()) {
      angularService.togglePersistentFilters();
    }
  }
  

  function getSidenavOrAngularService() {
    if (hasSidenavElement()) {
      return $mdSidenav(self.sidebarIdentifier);
    } else {
      const angularService = getAngularService();

      if (angularService && angularService.isActive()) {
        return angularService;
      }
    }
    return null;
  }

  function toggleFilterSidebar() {
    var elem = getSidenavOrAngularService();
    if (elem) {
      elem.toggle();
    }
  }

  function toggleLeftFilterSidebar() {
    var elem = getSidenavOrAngularService();
    if (elem) {
      if (elem.toggleLeft) {
        elem.toggleLeft();
      } else {
        elem.toggle();
      }
    }
  }

  function open() {
    var elem = getSidenavOrAngularService();
    if (elem) {
      elem.open();
    }
  }

  function openLeft() {
    var elem = getSidenavOrAngularService();
    if (elem) {
      if (elem.openLeft) {
        elem.openLeft();
      } else {
        elem.open();
      }
    }
  }

  function isOpen() {
    var elem = getSidenavOrAngularService();
    return elem ? elem.isOpen() : false;
  }

  function isLeftOpen() {
    var elem = getSidenavOrAngularService();
    return elem ? elem.isLeftOpen ? elem.isLeftOpen() : elem.isOpen() : false;
  }

  function setSelectedFilterInfo(listFilterBlocks) {
    if (listFilterBlocks) {
      var selectedFilterAmount = 0;
      var selectedFilterEntries = [];
      angular.forEach(listFilterBlocks, function (block) {
        angular.forEach(block.filterValues, function (filter) {
          switch (filter.type) {
            // string
            case 0:
              if (filter.stringValue) {
                selectedFilterAmount++;
                selectedFilterEntries.push({
                  name: filter.label,
                  value: filter.stringValue,
                });
              }
              break;
            // date
            case 2:
            // intentional fall-through
            // popup
            case 4:
              if (filter.stringValue) {
                selectedFilterAmount++;
                selectedFilterEntries.push({
                  name: filter.label,
                  value: filter.options.filter(function (option) {
                    return option.value == filter.stringValue;
                  })[0].label,
                });
              }
              break;
            // boolean
            case 1:
              if (filter.stringValue) {
                selectedFilterAmount++;
                selectedFilterEntries.push({
                  name: filter.label,
                  value: filter.label,
                });
              }
              break;
            // date range
            case 3:
              var startDate = filter.datePickerModel.dateStart;
              var endDate = filter.datePickerModel.dateEnd;
              if (startDate || endDate) {
                selectedFilterAmount++;
                var formattedDate = "";
                if (
                  typeof startDate === "string" &&
                  typeof endDate === "string"
                ) {
                  formattedDate = startDate + " - " + endDate;
                } else {
                  formattedDate =
                    startDate.toLocaleDateString() +
                    " - " +
                    endDate.toLocaleDateString();
                }
                selectedFilterEntries.push({
                  name: filter.label,
                  value: formattedDate,
                });
              }
              break;
            // checkbox group
            case 5:
              angular.forEach(filter.cboptions, function (option) {
                if (option.selected) {
                  selectedFilterAmount++;
                  selectedFilterEntries.push({
                    name: filter.label,
                    value: option.label,
                  });
                }
              });
              break;
            // autocomplete
            case 6:
              if (filter.selectedAutocompleteValue) {
                selectedFilterAmount++;
                selectedFilterEntries.push({
                  name: filter.label,
                  value: filter.selectedAutocompleteValue.value,
                });
              }
              break;
            // autocomplete string
            case 7:
              if (filter.selectedAutocompleteStringValue) {
                selectedFilterAmount++;
                selectedFilterEntries.push({
                  name: filter.label,
                  value: filter.selectedAutocompleteStringValue.value,
                });
              }
              break;
            default:
          }
        });
      });
      self.selectedFilter.amount = selectedFilterAmount;
      self.selectedFilter.entries = selectedFilterEntries;
    }
  }

  return {
    togglePersistentFilters: togglePersistentFilters,
    toggleFilterSidebar: toggleFilterSidebar,
    toggleLeftFilterSidebar: toggleLeftFilterSidebar,
    persistentFiltersCollapsed: self.persistentFiltersCollapsed,
    sidebarIdentifier: self.sidebarIdentifier,
    selectedFilter: self.selectedFilter,
    open: open,
    openLeft: openLeft,
    isOpen: isOpen,
    isLeftOpen: isLeftOpen,
    setSelectedFilterInfo: setSelectedFilterInfo,
  };
}
